import React from 'react'
import RegisterUser from '../../../components/Register/RegisterUser'

const Reu = () => (
  <RegisterUser type="Reu"/>
)

export default Reu
